var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundPlusWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.97942 4.93858H8.30223V8.29296H4.94786V9.97015H8.30223V13.3245H9.97942V9.97015H13.3338V8.29296H9.97942V4.93858ZM9.14083 0.745605C4.51179 0.745605 0.754883 4.50251 0.754883 9.13155C0.754883 13.7606 4.51179 17.5175 9.14083 17.5175C13.7699 17.5175 17.5268 13.7606 17.5268 9.13155C17.5268 4.50251 13.7699 0.745605 9.14083 0.745605ZM9.14083 15.8403C5.44263 15.8403 2.43207 12.8298 2.43207 9.13155C2.43207 5.43335 5.44263 2.42279 9.14083 2.42279C12.839 2.42279 15.8496 5.43335 15.8496 9.13155C15.8496 12.8298 12.839 15.8403 9.14083 15.8403Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundPlusWhite);
export default __webpack_public_path__ + "static/media/round-plus-white.560eb8b33179566fdfe022ac89328f2b.svg";
export { ForwardRef as ReactComponent };